import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import News from '@/pages/News'
import NewsDetail from '@/pages/news/Detail'
import Products from '@/pages/Products'
import ProductsDetail from '@/pages/products/productsDetail'
import ProductsDetail2 from '@/pages/products/new_daily_cab.vue'
import Contact from '@/pages/Contact'
import Loading from '@/pages/404'

Vue.use(Router)

export default new Router({
    mode: 'history',
    // mode: 'hash',
    base: '/',
    routes: [{
            path: '*',
            component: Home
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/news/detail/:id',
            name: 'NewsDetail',
            component: NewsDetail
        },
        {
            path: '/products',
            name: 'Products',
            component: Products
        },
        {
            path: '/products/new_daily_van',
            name: 'ProductsDetail',
            component: ProductsDetail
        },
        {
            path: '/products/new_daily_cab',
            name: 'ProductsDetail2',
            component: ProductsDetail2
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/loading',
            name: 'Loading',
            component: Loading
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js